export const INCLUDED_TIMED_POPUP_PATHS = [
  '/categories',
  '/products',
  '/product/[slugOrProductId]',
];

export const TIMED_POPUP_STORAGE_KEY = 'engagement_based_popup';
export const POST_ADD_TO_CART_POPUP_STORAGE_KEY =
  'post_add_to_cart_popup';
export const REFERRAL_INCENTIVE_POPUP_STORAGE_KEY =
  'referral_incentive_popup';
